<div class="col-xs-12">
  <div class="ibox float-e-margins">
    <div class="ibox-title">
      Filtros
    </div>
    <div class="ibox-content">
      <form>
        <div class="row">
          <div class="col-xs-12 col-md-6 col-lg-1">
            <label>Código</label>
            <input type="number" class="form-control" ng-model="filters.id">
          </div>

          <div class="col-xs-12 col-md-6 col-lg-4">
            <label>Máquina</label>
            <ui-select ng-model="filters.maquina" theme="bootstrap">
              <ui-select-match allow-clear="true" placeholder="">{{$select.selected.descricao | capitalize}}</ui-select-match>
              <ui-select-choices repeat="maquina in maquinas | filter: $select.search| limitTo: 50">
                <span class="form-group" ng-bind-html="maquina.descricao | capitalize | highlight: $select.search"></span>
              </ui-select-choices>
            </ui-select>
          </div>

          <div class="col-lg-3 col-md-6 col-xs-12">
            <label>Item de Manuteção</label>
            <ui-select ng-model="filters.itemManutencao" theme="bootstrap">
              <ui-select-match allow-clear="true" placeholder="">{{$select.selected.descricao | capitalize}}</ui-select-match>
              <ui-select-choices repeat="itemManutencao in itensManutencao | filter: $select.search| limitTo: 50">
                <span class="form-group" ng-bind-html="itemManutencao.descricao | capitalize | highlight: $select.search"></span>
              </ui-select-choices>
            </ui-select>
          </div>

          <div class="col-xs-12 col-md-6 col-lg-4">
            <label>Operador</label>
            <ui-select ng-model="filters.operador" theme="bootstrap">
              <ui-select-match allow-clear="true" placeholder="">{{$select.selected.nome | capitalize}}</ui-select-match>
              <ui-select-choices repeat="operador in operadores | filter: $select.search| limitTo: 50">
                <span class="form-group" ng-bind-html="operador.nome | capitalize | highlight: $select.search"></span>
              </ui-select-choices>
            </ui-select>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-3 col-md-6 col-xs-12">
            <label>Tipo</label>
            <ui-select ng-model="filters.tipo" theme="bootstrap">
              <ui-select-match allow-clear="true" placeholder="">{{$select.selected.descricao | capitalize}}</ui-select-match>
              <ui-select-choices repeat="tipo in tiposOcorrenciasMaquinas | filter: $select.search">
                <span class="form-group" ng-bind-html="tipo.descricao | capitalize | highlight: $select.search"></span>
              </ui-select-choices>
            </ui-select>
          </div>

          <div class="col-lg-3 col-md-6 col-xs-12">
            <label>Status</label>
            <ui-select ng-model="filters.status" theme="bootstrap">
              <ui-select-match allow-clear="true" placeholder="">{{$select.selected.descricao | capitalize}}</ui-select-match>
              <ui-select-choices repeat="status in filtroTiposStatusOcorrenciaMaquina | filter: $select.search">
                <span class="form-group" ng-bind-html="status.descricao | highlight: $select.search"></span>
              </ui-select-choices>
            </ui-select>
          </div>

          <div class="col-lg-4 col-md-6 col-xs-12">
            <label>Período</label>
            <div class="input-group">
              <input type="text" class="form-control" ng-model="filters.period.periodo" readonly id="periodo">
              <span class="input-group-btn">
                <button type="button" class="btn btn-danger"
                        title="Limpar"
                        ng-click="resetPeriodsFilter()"
                        ng-show="filters.period.periodo">
                  <i class="fa fa-eraser"></i>
                </button>
                <button type="button" class="btn btn-default"
                        title="Selecione o período"
                        ng-click="openPeriodsFilter()">
                  <i class="glyphicon glyphicon-calendar"></i>
                </button>
              </span>
            </div>
          </div>

          <div class="col-lg-2 col-md-6 col-xs-12 text-center">
            <label>&nbsp;</label><br>
            <button class="btn btn-success" ng-click="buscarClick()">
              Buscar <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>